var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ChangeModal',{attrs:{"help":"HelpAboutMe"}},[_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("About Me")])])
}
var staticRenderFns = []

export { render, staticRenderFns }